import { EditTabsPattern } from '@/components'
import ConfirmDialogContextProvider from '@/components/ConfirmDialogContext'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, Editor, History, SettingsTab } from './tabs'

const tabs = [
  { component: <SettingsTab />, name: 'settings' },
  { component: <Editor />, name: 'code-editor' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]

export const SimpleApiCall = () => {
  const { componentID, useUrl } = useComponentProvider()
  return (
    <ConfirmDialogContextProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmDialogContextProvider>
  )
}
